import { FC } from 'react';

interface BVErrorPageProps {
	errorCode: number;
	errorMessage: string;
}

export const BVErrorPage: FC<BVErrorPageProps> = ({
	errorCode,
	errorMessage,
}) => {
	return (
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: '#f5f7fa',
				padding: '24px',
				boxSizing: 'border-box',
			}}
		>
			<div
				style={{
					maxWidth: '480px',
					width: '100%',
					backgroundColor: '#ffffff',
					borderRadius: '12px',
					boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
					padding: '32px',
					textAlign: 'center',
				}}
			>
				<div
					style={{
						fontSize: '72px',
						fontWeight: 700,
						color: '#d32f2f',
						lineHeight: 1,
						marginBottom: '16px',
					}}
				>
					{errorCode}
				</div>

				<h1
					style={{
						fontSize: '20px',
						fontWeight: 600,
						color: '#1f2937',
						marginBottom: '8px',
					}}
				>
					An error occured!
				</h1>

				<p
					style={{
						fontSize: '14px',
						color: '#6b7280',
						marginBottom: '24px',
					}}
				>
					{errorMessage}
				</p>
			</div>
		</div>
	);
};
